<template>
  <v-card-text class="d-flex flex-column justify-space-around align-center metrics-card-text">
    <div class="d-flex flex-column align-center">
      <p class="text--primary">Whizeo Health Score</p>
      <p  v-if="!failed">(Last updated: {{ whizeoHealthScore.data.createdDateTimeUTC | formatDate }})</p>
    </div>
    <v-progress-circular v-if="loading" indeterminate size="64" />
    <template v-if="loaded">
      <template v-if="!whizeoHealthScore.data.codeWorking">
        <v-alert type="error" prominent>
          Code not working
        </v-alert>
      </template>
      <template v-else>
        <health-score-icon :satisfaction-level="score" />
        <p>
          <v-chip left small>
            {{ whizeoHealthScore.data.recentEventsCount }}
          </v-chip>
          events in past 2 hours
        </p>
      </template>
    </template>
    <v-alert v-if="failed" type="warning" outlined>
      No system rating available.
    </v-alert>
  </v-card-text>
</template>

<script>
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import HealthScoreIcon from "@/components/HealthScore/CustomerOverview/HealthScoreIcon.vue";
import {dateToTimeDateString} from "@/helpers/dateHelper";

export default {
  name: "WhizeoHealthScore",
  components: {HealthScoreIcon},
  computed: {
    ...mapState('healthScoreStore', ['whizeoHealthScore']),
    loading() {
      return this.whizeoHealthScore.state === LoadingState.LOADING;
    },
    loaded() {
      return this.whizeoHealthScore.state === LoadingState.LOADED;
    },
    failed() {
      return this.whizeoHealthScore.state === LoadingState.FAILED;
    },
    score() {
      return this.whizeoHealthScore.data.score;
    }
  },
  filters: {
    formatDate: function (value) {
      return dateToTimeDateString(value);
    }
  },
}
</script>

<style scoped>

</style>